import script from "./PromoterBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PromoterBanner.vue?vue&type=script&setup=true&lang=js"

import "./PromoterBanner.vue?vue&type=style&index=0&id=173137e0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-173137e0"]])

export default __exports__